import '../assets/NcAppNavigationNewItem-C574fgtB.css';
import { N as a } from "./NcInputConfirmCancel-D5GYt1Th.mjs";
import i from "../Components/NcLoadingIcon.mjs";
import { n as l } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "NcAppNavigationNewItem",
  components: {
    NcInputConfirmCancel: a,
    NcLoadingIcon: i
  },
  props: {
    /**
     * The name of the element.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Refers to the icon on the left, this prop accepts a class
     * like 'icon-category-enabled'.
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Displays a loading animated icon on the left of the element
     * instead of the icon.
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * Only for 'editable' items, sets label for the edit action button.
     */
    editLabel: {
      type: String,
      default: ""
    },
    /**
     * Sets the placeholder text for the editing form.
     */
    editPlaceholder: {
      type: String,
      default: ""
    }
  },
  emits: ["new-item"],
  data() {
    return {
      newItemValue: "",
      newItemActive: !1
    };
  },
  methods: {
    handleNewItem() {
      this.loading || (this.newItemActive = !0, this.$nextTick(() => {
        this.$refs.newItemInput.focusInput();
      }));
    },
    cancelNewItem() {
      this.newItemActive = !1;
    },
    handleNewItemDone() {
      this.$emit("new-item", this.newItemValue), this.newItemValue = "", this.newItemActive = !1;
    }
  }
};
var o = function() {
  var e = this, t = e._self._c;
  return t("li", { staticClass: "app-navigation-entry", class: {
    "app-navigation-entry--newItemActive": e.newItemActive
  } }, [t("button", { staticClass: "app-navigation-entry-button", on: { click: e.handleNewItem } }, [t("span", { staticClass: "app-navigation-entry-icon", class: { [e.icon]: !e.loading } }, [e.loading ? t("NcLoadingIcon") : e._t("icon")], 2), e.newItemActive ? e._e() : t("span", { staticClass: "app-navigation-new-item__name", attrs: { title: e.name } }, [e._v(" " + e._s(e.name) + " ")]), e.newItemActive ? t("span", { staticClass: "newItemContainer" }, [t("NcInputConfirmCancel", { ref: "newItemInput", attrs: { placeholder: e.editPlaceholder !== "" ? e.editPlaceholder : e.name }, on: { cancel: e.cancelNewItem, confirm: e.handleNewItemDone }, model: { value: e.newItemValue, callback: function(n) {
    e.newItemValue = n;
  }, expression: "newItemValue" } })], 1) : e._e()])]);
}, c = [], m = /* @__PURE__ */ l(
  s,
  o,
  c,
  !1,
  null,
  "8950be04",
  null,
  null
);
const u = m.exports;
export {
  u as N
};
